'use client';

import { Link } from '@coolblue-development/freddy';
import clearAllFiltersTrigger from '@coolblue-development/ga4-events/triggers/FilterAndSort/clearAllFiltersTrigger';
import { ArrowRight } from '@coolblue-development/icons';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { FilterPageContext } from '@features/filter/context';
import { useTranslation } from '@i18n/useTranslation';
import { useContext } from 'react';

export const ClearAllFiltersButton = ({ showStartIcon }: { showStartIcon?: boolean }) => {
  const { clearFilters, trackingSubFeature } = useContext(FilterPageContext);
  const { t } = useTranslation('webshop.filterPage.selectedFilters');
  const { trackEvent } = useAnalytics();

  return (
    <Link
      component='button'
      onClick={() => {
        trackEvent(
          clearAllFiltersTrigger({
            sub_feature: trackingSubFeature
          })
        );
        clearFilters?.();
      }}
      {...(showStartIcon && { startIcon: <ArrowRight /> })}
    >
      {t('clearAllFilters')}
    </Link>
  );
};
